import { defineStore } from 'pinia';
import useSessionStorage from '@/composables/storage/useSessionStorage';

const STORAGE_KEY = 'error';

const defaultError = () => ({
    code: null,
    message: null,
    traceId: null,
    returnUrl: null,
    tracked: false,
});

export const useErrorStore = defineStore({
    id: 'error',
    state: () => ({
        error: defaultError(),
    }),
    actions: {
        setError({
            code = null, message = null, traceId = null, returnUrl = null,
        } = {}) {
            const { bindSessionStorage } = useSessionStorage();
            this.error = {
                code,
                message,
                traceId,
                returnUrl,
                tracked: false,
            };
            bindSessionStorage(STORAGE_KEY, this.error);
        },
        markTracked() {
            const { bindSessionStorage } = useSessionStorage();
            this.error.tracked = true;
            bindSessionStorage(STORAGE_KEY, this.error);
        },
        clearError() {
            const { removeSessionStorageByKey } = useSessionStorage();
            this.error = defaultError();
            removeSessionStorageByKey(STORAGE_KEY);
        },
        hydrateFromSession() {
            const { checkSessionStorage } = useSessionStorage();
            const persisted = checkSessionStorage(STORAGE_KEY, null);
            if (!persisted) {
                return;
            }
            this.error = {
                ...defaultError(),
                ...persisted,
            };
        },
    },
    getters: {
        getError(store) {
            return store.error;
        },
    },
});
